export default __webpack_public_path__ + "static/media/marker.28550d69.svg";